import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Marks an HTML string as trusted for use with [innerHTML].
 *
 * SECURITY WARNING: this pipe calls `bypassSecurityTrustHtml`, which disables
 * Angular's built-in XSS sanitization. Any `<script>`, inline event handlers
 * (`onerror`, `onload`, ...) or `javascript:` URLs in the input WILL execute.
 *
 * Only use with HTML coming from a trusted source that has been sanitized
 * server-side (e.g. DOMPurify on the backend or a tag whitelist).
 */
@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value ?? '');
  }
}
